import CryptoJS from "crypto-js";

import { fetchConfig } from "./configService";

let CONFIG = null; // Store config globally

// Function to initialize config
const initializeConfig = async () => {
  if (!CONFIG) {
    CONFIG = await fetchConfig();
  }
};

initializeConfig()

const getConfigValue = (key, fallback = "") => {
  return CONFIG?.[key] || fallback;
};

const PART_LENGTH = "1000";
const JWT_SECRET = () => getConfigValue("jwtSecret");

const key = () => getConfigValue("encryption");

// const KEY1 = key().key1
// const KEY2 = key().key2
// const KEY3 = key().key3

const KEY1 = "BUiJ6YioLLCKGgRJdaJZ2NTrunwJOBvf"
const KEY2 = "SidsowED/NnnW43y3UCPbt545FeXOkCK"
const KEY3 = "haNTWTgKZLF9aXaUppKPqPHQBFPwZCSo"

const CHUNK_JOIN_SPLIT_STR = "asdkljqweopi";

const encryptAES = (data, key, iv) => {
  let cipherText = CryptoJS.AES.encrypt(data, key).toString();

  return cipherText;
};

const decryptAES = (data, key, iv) => {
  let decryptedData = CryptoJS.AES.decrypt(data, key).toString(
    CryptoJS.enc.Utf8
  );

  return decryptedData;
};

const encryptDataToArray = (data) => {
  try {
    if (!data) {
      return data;
    }

    let stringifiedData = data;

    if (typeof data === "object") {
      stringifiedData = JSON.stringify(data);
    }

    let chunk = [];
    let chunkLength = 0;

    while (chunkLength < stringifiedData?.length) {
      let random = Math.random() * PART_LENGTH;
      chunk.push(stringifiedData?.slice(chunkLength, chunkLength + random));

      chunkLength += random;
    }

    let finalResult = [];

    for (let ch of chunk) {
      let firstEnc = encryptAES(ch, KEY1);

      let secondEnc = encryptAES(firstEnc, KEY2);

      let thirdEnc = encryptAES(secondEnc, KEY3);

      finalResult.push(thirdEnc);
    }

    return finalResult;
  } catch (err) {
    return data;
  }
};

const decryptDataFromArray = (data) => {
  try {
    if (!data) {
      return data;
    }

    let encryptedData = data;

    if (!Array.isArray(encryptedData)) {
      encryptedData = encryptedData?.split(CHUNK_JOIN_SPLIT_STR);
    }

    let actualEncrypted = [];

    for (let enc of encryptedData) {
      let thirdDec = decryptAES(enc, KEY3);

      let secondDec = decryptAES(thirdDec, KEY2);

      let firstDec = decryptAES(secondDec, KEY1);

      actualEncrypted.push(firstDec);
    }

    let finalResult = actualEncrypted?.join("");
    if (["{", "["].some((ch) => actualEncrypted?.[0]?.startsWith(ch))) {
      finalResult = JSON.parse(finalResult);
    }

    return finalResult;
  } catch (err) {
    return data;
  }
};

export {
  JWT_SECRET,
  CHUNK_JOIN_SPLIT_STR,
  encryptDataToArray,
  decryptDataFromArray,
};
